export default {
  columns: {
    title: 'Otsikko',
    image: 'Kuva',
    button_url: 'Painikkeen URL',
    button_text: 'Painikkeen teksti',
    description: 'Kuvaus',
    visible: 'Näkyvissä',
    actions: 'Toiminnot',
  },
  buttons: {
    create_post: 'Luo julkaisu',
    edit: 'Muokkaa',
    delete: 'Poista',
    cancel: 'Peruuta',
    confirm: 'Vahvista',
  },
  title: 'Nostetut julkaisut',
  delete_confirmation: 'Haluatko varmasti poistaa tämän julkaisun?',
};
